document.addEventListener('DOMContentLoaded' , () =>{
    // tab    
    const tabModule = document.querySelectorAll('.js_tabModule');

    class tab {
        constructor(target) {
            this.target = target;
            this.tabBtnArray = Array.from(this.target.querySelectorAll('.js_btn'));
            this.tabConArray = Array.from(this.target.querySelectorAll(".js_tabContents"));
        }
    
        tabFn() {
            const _this = this;
            
            this.tabBtnArray.forEach(function(el,index){
                el.addEventListener("click" , function(){
                    // console.log(_this.tabBtnArray.indexOf(el) , index) 1,1 / 2,2
                    // if(tabBtnArray.indexOf(index) == -1){                         
                    // }                    

                    
                    if(_this.target.parentElement.classList.contains('prd-top__filter')){
                        console.log(_this.target.parentElement.dataset.currentNum)
                        if(_this.target.parentElement.dataset.currentNum !== `${index}`){
                            console.log('index 다름')
                            console.log(index)
                            _this.tabBtnArray.forEach(function(el){
                                el.classList.remove("on");
                            });                    
    
                            _this.tabBtnArray[index].classList.add("on");         
    
                            _this.tabConArray.forEach(function(el){
                                el.classList.remove("on");
                            })
    
                            _this.tabConArray[index].classList.add("on");
                            _this.target.parentElement.dataset.currentNum = index;
                        }else{
                            console.log('index 같음')
                            console.log(index)
                            _this.tabBtnArray[index].classList.toggle("on");
    
                            _this.tabConArray[index].classList.toggle("on");
                            _this.target.parentElement.dataset.currentNum = index;
                        }
                    }else{
                        _this.tabBtnArray.forEach(function(el){
                            el.classList.remove("on");
                        });                    

                        _this.tabBtnArray[index].classList.add("on");         

                        _this.tabConArray.forEach(function(el){
                            el.classList.remove("on");
                        })

                        _this.tabConArray[index].classList.add("on");
                    }

                    // mypage - review - all-review
                    if(document.querySelector('.all-review')){
                        let standardHgt,
                            reviewFlexBox = document.querySelectorAll('.all-review__flex-box');

                        if(window.innerWidth <= 768){
                            //MB
                            standardHgt = 52;
                        }else{
                            //PC
                            standardHgt = 60;
                        }

                        reviewFlexBox.forEach((el) =>{
                            let reviewConHgt = el.querySelector('.all-review__content').clientHeight;

                            if(reviewConHgt >= standardHgt){
                                el.classList.add('more-on');

                                let reviewMoreBtn = document.querySelectorAll('.more-on .all-review__content-more');

                                reviewMoreBtn.forEach((el) =>{
                                    el.addEventListener("click" , function(){
                                        el.parentElement.classList.remove('more-on');
                                        el.style.display = 'none';
                                    })
                                })
                            }
                        })
                    }
                })
            })
        }
    }    
    tabModule.forEach(el => {        
        new tab(el).tabFn();
    });
});
